import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function SimpleProcess() {
  const { ref, isVisible } = useScrollReveal();

  const steps = [
    {
      number: "1",
      title: "Connect your channel",
      description: "Link your monetized YouTube channel to Enfinity. We'll verify your eligibility instantly.",
    },
    {
      number: "2",
      title: "Setup payment method",
      description: "Select your preferred payout method: PayPal, bank transfer, or cryptocurrency.",
    },
    {
      number: "3",
      title: "Select payout option",
      description: "Select your preferred payout frequency: daily, early, or advance payout.",
    },
    {
      number: "4",
      title: "Track your earnings",
      description: "View your monthly revenue and growth analytics right from your dashboard.",
    },
  ];

  return (
    <div
      id="how-it-works"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-16 lg:py-16 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col gap-[30px] items-center text-center mb-16">
          {/* Label */}
          <p className="text-[#757575] text-[18px] 4xl:text-[24px] font-medium enfinity-subtext-font">
          Fast, simple, and stress free
          </p>

          {/* Main Heading */}
          <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal text-black leading-[106px] xxs:leading-tight xs:leading-tight sm:leading-tight md:leading-tight lg:leading-normal enfinity-header-font">
            <span>Get started in </span>
            <span className="text-[#00A656] enfinity-header-font">4 simple steps</span>
          </h1>

          {/* Description */}
          <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] max-w-[728px]">
            Join thousands of creators who have transformed their YouTube channels into thriving businesses with Enfinity.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="flex flex-col md:flex-row items-start justify-center lg:gap-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col gap-[31px] items-center text-center w-full md:w-[332px] "
            >
              {/* Numbered Circle */}
              <div className="relative w-[82px] h-[82px] flex items-center justify-center">
                <div 
                  className="absolute inset-0 rounded-full"
                  style={{ backgroundImage: "linear-gradient(137.738deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)" }}
                />
                <p className="relative text-[40px] font-extrabold text-white text-center">
                  {step.number}
                </p>
              </div>

              {/* Step Content */}
              <div className="flex flex-col gap-[19px] items-center text-center w-full pb-16">
                <p className="text-[24px] font-medium text-black leading-normal enfinity-header-font">
                  {step.title}
                </p>
                <p className="text-[20px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-[34px] enfinity-subtext-font">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

